import { useTranslation } from "react-i18next";
import SectionHeader from "../../../../../util/component/SectionHeader";
import CreatePrintout from '../sections/CreatePrintout';

const RoyaltiesPrintoutWizard = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'royalties' });

    return (
        <>
            <SectionHeader title={t('printout-wizard.title')} subtitle={t('printout-wizard.subtitle')}/>
            <CreatePrintout/>
        </>
    )
}

export default RoyaltiesPrintoutWizard;